module.exports = __webpack_public_path__ + "img/Info Icon - charcoal.5b54ada8.svg";